export const prod = true;
export const url = '//api52wan.001zhegame.com';// hg
// export const url = '//api.gamebox.05zhegame.com'; // 0.05 0.01 hz